module.exports = __webpack_public_path__ + "img/9788937442100.585056c4.jpg";